import { render, staticRenderFns } from "./PazienteTerapieAttive.vue?vue&type=template&id=ca421cd2&scoped=true"
import script from "./PazienteTerapieAttive.vue?vue&type=script&lang=js"
export * from "./PazienteTerapieAttive.vue?vue&type=script&lang=js"
import style0 from "./PazienteTerapieAttive.vue?vue&type=style&index=0&id=ca421cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca421cd2",
  null
  
)

export default component.exports